import Vue from "vue";
import VueDateFns from "vue-date-fns";
import locale from "date-fns/locale/pt-BR";

Vue.use(VueDateFns, "dd/MM/yyyy", { locale });
